<template>
    <div>
        <div class="row" style="margin-bottom: 0;">
            <div class="col s12 offset-m2 m8 offset-l3 l6 offset-xl3 xl6">
                <h5 class="center-align white-text">
                    Создание нового пользователя
                </h5>
            </div>
        </div>
        <div class="row">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <table class="highlight card bg"
                       :data-login="user.login"
                       :data-id="user.id">
                    <tbody>
                    <tr>
                        <td colspan="2" class="row">
                                <a @click="$router.push('/users')"
                                   style="width: 50px;"
                                   class="btn grey darken-3 waves-effect
									    waves-light btn-small col s12 m5 l5 xl5 right">
                                    <i class="material-icons">keyboard_backspace</i>
                                </a>
                        </td>
                    </tr>
                    <tr :key="user.id">
                        <td>логин</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="textarea2"
                                                  class="materialize-textarea"
                                                  v-model="user.login">
										</textarea>
                                <label for="textarea2"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>заметка</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="textarea1"
                                                  class="materialize-textarea"
                                                  v-model="user.note">
										</textarea>
                                <label for="textarea1"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>включен</td>
                        <td>
                            <label>
                                <input type="checkbox"
                                       v-model="user.enabled"/>
                                <span></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>Запись DVR</td>
                        <td>
                            <label>
                                <input type="checkbox"
                                       v-model="user.dvr_allowed"/>
                                <span></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>пароль</td>
                        <td class="tooltipped darken-3 bold">
                            <div class="input-field col s12 m12 l12 offset-xl2 xl8">
                                <input type="password"
                                       id="autocomplete-pass"
                                       @keyup="setPass($event)"
                                       @blur="blur"
                                       v-model.lazy="user.pass"
                                       :class="((user.pass !== user.confirmPass)
									                        && ($v.confirmPass.$dirty && $v.pass.$dirty))
									                        ?
									                        'error'
									                        : null"
                                       autocomplete="off"
                                       class="autocomplete">
                                <label for="autocomplete-pass"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>подтверждение пароля</td>
                        <td class="tooltipped darken-3 bold">
                            <div class="input-field col s12 m12 l12  offset-xl2 xl8">
                                <input type="password"
                                       id="autocomplete-confirm-pass"
                                       @keyup="setConfirmPass($event)"
                                       @blur="blur"
                                       v-model.lazy="confirmPass"
                                       :class="((user.pass !== user.confirmPass)
									                        && ($v.confirmPass.$dirty && $v.pass.$dirty))
								                            ?
								                            'error'
									                        : null"
                                       autocomplete="off"
                                       class="autocomplete">
                                <label for="autocomplete-confirm-pass"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="row"
                            colspan="2">
                            <a class="btn indigo lighten-1 waves-effect waves-light btn-small col s12 m5 l5 xl5"
                               style="margin: 5px 0; visibility: hidden">
                                <i class="material-icons left">videocam</i>
                                список камер
                            </a>
                            <div class="col hide-on-small-only m2 l2 xl2"></div>
                            <a @click="save"
                               style="margin: 5px 0;"
                               :class="{disabled: (user.pass !== user.confirmPass)
					                        && ($v.confirmPass.$dirty && $v.pass.$dirty)}"
                               class="btn teal lighten-1 waves-effect
									    waves-light btn-small width-btn col s12 m5 l5 xl5">
                                <i class="material-icons left"
                                >save</i>
                                Создать</a>

                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import setRules from "../../assets/setRules";
    import {eventEmitter} from "../../main";
    import {mapState, mapMutations} from "vuex";
    import Swal from 'sweetalert2'
    import Users from "../../plugins/controllers/users";

    export default {
        name: "EditUser",
        data() {
            return {
                pass: "",
                confirmPass: "",
                user: {
                    enabled: null,
                    login: "",
                    note: "",
                    dvr_allowed: null,
                    pass: null,
                    confirmPass: null,
                    camera_count: 0
                }
            };
        },
        validations: {
            pass: {},
            confirmPass: {}
        },
        beforeMount() {
            eventEmitter.$once("tokenSuccess", this.getAdmin);
        },
        beforeDestroy() {
            eventEmitter.$off("tokenSuccess", this.getAdmin);
        },
        mounted() {
            if (this.tokenSuccess) {
                this.getUser();
            } else {
                console.log("token is not success");
            }
        },
        computed: {
            ...mapState(["tokenSuccess"])
        },
        methods: {
            ...mapMutations(["setAuth", "setShowMenu"]),
            save() {
                let savedUser = {
                    enabled: this.user.enabled,
                    login: this.user.login,
                    note: this.user.note,
                    password: this.user.pass,
                    dvr_allowed: this.user.dvr_allowed,
                };
                let swalOptions = {
                    title: 'Создать нового пользователя?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Отмена',
                    confirmButtonText: 'Создать!'
                };
                Swal.fire(swalOptions).then((result) => {
                    if (result.value) {
                        Users.createUser(savedUser).then((response) => {
                            setRules(response);
                            if (Number.isInteger(response.data.id)) {
                                Swal.fire(
                                    'Созданно!',
                                    'Пользователь создан',
                                    'success'
                                ).then((result) => {
                                    this.$router.push("/users");
                                })
                            } else {
                                Swal.fire(
                                    'Не Созданно!',
                                    'Пользователь не был создан.',
                                    'error'
                                )
                            }
                        }).catch((error) => {
                            Swal.fire(
                                'Не Созданно!',
                                'Возникла ошибка на сервере',
                                'error'
                            )
                        });
                    }
                })
            },
            getUser() {
                console.log(this.$route.params.login);
                Users.getUser(this.$route.params.login).then((response) => {
                    setRules(response);
                    //   console.log(response.data);
                    this.user.enabled = response.data.enabled;
                    this.user.id = response.data.id;
                    this.user.login = response.data.login;
                    this.user.note = response.data.note;
                    this.user.dvr_allowed = response.data.dvr_allowed;
                    this.user.pass = response.data.password;
                    this.user.camera_count = response.data.camera_count;
                }).catch((error) => {
                    console.log(error)
                })
            },
            blur() {
                if (this.$v.confirmPass.$dirty && this.$v.pass.$dirty) {
                    this.user.pass = this.pass;
                    this.user.confirmPass = this.confirmPass;
                }
            },
            setPass(event) {
                this.pass = event.target.value;
                this.$v.pass.$touch();
            },
            setConfirmPass(event) {
                if (event.target.value === "") {
                    this.$v.confirmPass.$reset();
                } else {
                    this.$v.confirmPass.$touch();
                }
                this.confirmPass = event.target.value;
            }
        }
    };
</script>
<style scoped lang="scss">
    .bold {
        font-weight: 500;
    }

    @media screen and (max-width: 600px) {
        h5 {
            font-size: 16px;
            margin-bottom: 0;
        }
    }

    .bg {
        background-color: rgba(56, 56, 56, 0.8);
    }

    input[type="password"] {
        transition: all 0.3s
    }

    input[type="password"].disable {
        visibility: hidden;
    }

    input[type="password"].error {
        color: #c62828;
        border-bottom: 1px solid #c62828;
        box-shadow: 0 1px 0 #c62828;

        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #c62828;
            box-shadow: 0 1px 0 #c62828;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #c62828;
        }
    }

    textarea, input {

        color: #fff;
        transition: all 0.3s;
    }

    textarea:not(.browser-default):focus:not([readonly]) {
        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #4d5ff1;
            box-shadow: 0 1px 0 #4c5edf;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #4d5ff1;
        }
    }

    input[type="password"], input[type="text"] {
        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #4d5ff1;
            box-shadow: 0 1px 0 #4c5edf;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #4d5ff1;
        }
    }

    [type="checkbox"]:checked + span:not(.lever):before {
        border: 2px solid transparent;
        border-right-color: white;
        border-bottom-color: white;
    }

    [type="checkbox"] + span:not(.lever):before {
        border: 2px solid white;
    }

    .parallax-container {
        height: auto;
    }

    table.highlight > tbody > tr > td {
        padding: 7px 10px;
        font-size: 14px;
    }

    table.highlight > tbody > tr > td:first-child {
        padding-left: 12px;
    }

    table.highlight > tbody > tr:hover {
        background-color: rgba(36, 37, 40, 0.51);
    }

    .input-field {
        padding-right: 0;
        margin: 0;
    }

    tr td:first-child {
        width: 20%;
        font-weight: 600;
        text-transform: uppercase;
    }

    tr td:last-child {
        text-align: center;
    }

    .width-btn {
        margin: 10px;
    }
</style>
